import { useContext} from "react";
import Modal from "../modal";
import Question from "../modal/question";
import AcceptProposal from "../modal/acceptProposal";
import { AppContext } from "../../context/store";

const ProposalSlide = ({ children, onNext, onPrev }) => {
  const { question, accept } = useContext(AppContext);
  const [isQuestionOpen,setQuestionOpen] = question
  const [isAcceptOpen,setAcceptOpen] = accept

  const closeQuestion = () => setQuestionOpen((open) => !open);
  const closeAccept = () => setAcceptOpen((open) => !open);

  return (
    <div className="px-2 py-4 flex-shrink-0 w-full sm:px-4 bg-gray-100 rounded-3xl overflow-y-auto">
      <div className="flex justify-end items-center gap-4">
      <button
        className="h-[36px] px-4 text-md rounded-md font-semibold text-white bg-black uppercase hidden sm:block hover:bg-green-600 transition-colors duration-300"
        onClick={closeAccept}
      >
        STATUS
      </button>

        <button
        className="py-1 px-2 h-[36px] rounded-md bg-gray-300 flex-col items-center hidden sm:flex hover:bg-yellow-500 hover:text-white transition-colors duration-300"
        onClick={closeQuestion}
      >
        <span className="material-symbols-outlined text-[15px]">
          speaker_notes
        </span>
        <span className="text-[8px] font-semibold">Questions</span>
      </button>

        <button
          className="h-[36px] w-10 rounded-md bg-gray-300 flex items-center justify-center hover:bg-black hover:text-white transition-colors duration-300"
          onClick={onPrev}
        >
          <span className="material-symbols-outlined text-lg font-semibold">
            arrow_back_ios
          </span>
        </button>
      
        <button
          className="h-[36px] w-10 rounded-md bg-gray-300 flex items-center justify-center hover:bg-black hover:text-white transition-colors duration-300"
          onClick={onNext}
        >
          <span className="material-symbols-outlined text-lg font-semibold">
            arrow_forward_ios
          </span>
        </button>
      </div>
      <div className="w-full mt-4 h-[calc(100vh-186px)] overflow-y-auto">
        {children}
      </div>

      <Modal isOpen={isAcceptOpen}>
        <AcceptProposal onClose={closeAccept} />
      </Modal>

      <Modal isOpen={isQuestionOpen} onOutsideClick={closeQuestion}>
        <Question onClose={closeQuestion} />
      </Modal>
    </div>
  );
};

export default ProposalSlide;
